let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3runj")).then(() => parcelRequire('8dyHT'));